// @systeme: contrat
// Entrées et sorties des routes d'authentification.
import { z } from 'zod';
import { SchemaClePlan, SchemaInterrupteurs, SchemaRoleMembre, SchemaZoneScolaire, } from '../enumerations.js';
/** Une adresse, nettoyée (espaces, majuscules) avant d'être vérifiée. */
const SchemaEmail = z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email({ error: 'Cette adresse ne ressemble pas à un courriel.' }).max(254));
const SchemaMotDePasse = z
    .string()
    .min(8, { error: 'Le mot de passe doit faire au moins 8 caractères.' })
    .max(200);
const SchemaPrenom = z.string().trim().min(1, { error: 'Ton prénom nous manque.' }).max(60);
export const SchemaInscription = z.object({
    email: SchemaEmail,
    motDePasse: SchemaMotDePasse,
    prenom: SchemaPrenom,
    /** Le jeton d'une invitation : on rejoint ce foyer au lieu d'en créer un. */
    invitation: z.string().max(200).optional(),
    /** Obligatoire : les CGU et la politique de confidentialité, lues et acceptées. */
    cguAcceptees: z.literal(true, { error: 'Il faut accepter les conditions pour continuer.' }),
});
export const SchemaConnexion = z.object({
    email: SchemaEmail,
    motDePasse: z.string().min(1, { error: 'Le mot de passe est vide.' }).max(200),
});
export const SchemaMotDePasseOublie = z.object({ email: SchemaEmail });
export const SchemaVerificationCourriel = z.object({ jeton: z.string().min(10).max(2000) });
/** Un foyer de l'utilisatrice, pour en changer. */
export const SchemaFoyerResume = z.object({
    id: z.uuid(),
    nom: z.string(),
    role: SchemaRoleMembre,
    courant: z.boolean(),
});
export const SchemaReinitialisation = z.object({
    jeton: z.string().min(10).max(2000),
    motDePasse: SchemaMotDePasse,
});
/** L'utilisatrice connectée, telle que le client la voit. Jamais de hash ici. */
export const SchemaUtilisateur = z.object({
    id: z.uuid(),
    email: z.string(),
    prenom: z.string(),
    courrielVerifieLe: z.iso.datetime({ offset: true }).nullable(),
    /** Administratrice (adresses réglées dans la configuration du serveur, DEC-011). */
    admin: z.boolean().default(false),
    /** Suppression du compte demandée : la date de l'effacement, annulable jusque-là. */
    suppressionPrevueLe: z.iso.datetime({ offset: true }).nullable().default(null),
});
/** L'espace courant, résumé pour l'écran Moi. */
export const SchemaEspaceResume = z.object({
    id: z.uuid(),
    nom: z.string(),
    role: SchemaRoleMembre,
    planCle: SchemaClePlan,
    essaiFinLe: z.iso.date().nullable(),
    /** Vrai quand l'assistant se repose (essai fini, impayé, résilié et période écoulée). Tout le reste marche. */
    modeAllege: z.boolean().default(false),
    /** Un accès support est ouvert sur ce foyer jusqu'à cet instant (DEC-011) : on le dit. */
    accesSupportJusquau: z.iso.datetime({ offset: true }).nullable().default(null),
    /** La zone scolaire du foyer (A, B, C, Corse), pour comprendre « avant les vacances ». */
    zoneScolaire: SchemaZoneScolaire.nullable().default(null),
});
export const SchemaReponseSession = z.object({
    utilisateur: SchemaUtilisateur,
    espace: SchemaEspaceResume,
    /** Les interrupteurs de l'admin : ce qui est éteint n'apparaît pas. */
    fonctionnalites: SchemaInterrupteurs.default({}),
});
//# sourceMappingURL=auth.js.map